var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('v-header'),_c('v-sidebar'),_c('div',{staticClass:"content-box",class:{ 'content-collapse': _vm.collapse }},[_c('div',{staticClass:"contente"},[_c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }